const MAIN_URL = process.env.REACT_APP_URL;

export const requestUrls = {
  accounts: `${MAIN_URL}/accounts`,
  wallets: `${MAIN_URL}/wallets`,
};
